/**
 * 模块: OpportunityKeywordsTab
 * 职责: 机会词挖掘Tab组件
 * 限制: <280行
 */

import React from 'react';
import { Card, Table, Empty, Spin } from 'antd';
import type { OpportunityKeywordsResult } from '../../../types';
import {
  highPriorityOpportunityColumns,
  mediumPriorityOpportunityColumns,
} from './tableColumns';

interface OpportunityKeywordsTabProps {
  data: OpportunityKeywordsResult | null;
  loading: boolean;
}

export const OpportunityKeywordsTab: React.FC<OpportunityKeywordsTabProps> = ({
  data,
  loading,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" tip="加载机会词分析..." />
      </div>
    );
  }

  if (!data) {
    return <Empty description="暂无机会词数据" />;
  }

  return (
    <div>
      <Card title="🔴 高优先级机会词（大盘强 + ASIN弱）" size="small" style={{ marginBottom: 16 }}>
        <Table
          dataSource={data.high_priority || []}
          columns={highPriorityOpportunityColumns}
          scroll={{ y: 400 }}
          sticky={{ offsetHeader: 0 }}
          pagination={{ pageSize: 20 }}
          size="small"
        />
      </Card>

      {data.medium_priority && data.medium_priority.length > 0 && (
        <Card title="🟡 中等机会词" size="small">
          <Table
            dataSource={data.medium_priority || []}
            columns={mediumPriorityOpportunityColumns}
            scroll={{ y: 300 }}
            sticky={{ offsetHeader: 0 }}
            pagination={{ pageSize: 10 }}
            size="small"
          />
        </Card>
      )}
    </div>
  );
};

